<template>
  <Select
    v-model="categoryNames"
    @filter="onFilter"
    @onClear="onClear"
    :options="getOptions"
    title="Kategori"
    :placeholder="getPlaceholder"
    v-readonly
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>
<script>
import Select from './Select';

export default {
  name: 'CategorySelect',
  components: { Select },
  props: {
    value: {
      type: Array,
      default: () => ([]),
    },
    options: {
      type: Array,
      default: () => ([]),
    },
  },
  data () {
    return {
      categories: [],
      categoryNames: [],
    };
  },
  computed: {
    getOptions () {
      return this.categories;
    },
    getPlaceholder () {
      return this.$attrs.placeholder || 'Ekleyeceğiniz ürünün kategorisiniz seçiniz';
    },
  },
  methods: {
    onClear () {
      this.$emit('input', {});
    },
    onFilter (categories, categoryNames) {
      this.categoryNames = categoryNames;
      this.$emit('categoryFilter', categories, categoryNames);
    },
    setCategories () {
      this.options.map(option => {
        if (this.categoryNames.find(category => category === option.Name)) {
          this.categories.push({
            label: option.Name,
            id: option.Id,
            isChecked: true,
          });
        } else {
          this.categories.push({
            label: option.Name,
            id: option.Id,
            isChecked: false,
          });
        }
      });
    },
  },
  created () {
    this.categoryNames = this.value;
    this.setCategories();
  },
};
</script>
